import axios from 'axios';

export const registerReligiousPlaceService = async (formData) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/religious_place/register`, formData)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const updateReligiousPlaceService = async (formData) => {
    try {
        return await axios.put(`${process.env.REACT_APP_API_URL}/api/religious_place/update`, formData)
        .then((response)=>{
            return {success: true, data: response?.data, message: 'update_success'}
        }).catch((error)=>{
            console.log(error)
            return {success: false, data: null, message: error.response.data.message || 'generic_server_error_message'}
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const getReligiousPlaceService = async (created_by) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religious_place/get_by_created_by/${created_by}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listByFiltersReligiousPlaceService = async (filters) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/religious_place/list_by_filters`,{filters})
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listPicturesByCreatedByService = async (user_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religious_place_picture/list_pictures_by_created_by/`+user_access_key)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const getPictureLogoService = async (user_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religious_place_picture/get_logo_by_created_by/${user_access_key}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const deletePicturesService = async (id, filename) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_API_URL}/api/religious_place_picture/delete/${id}/${filename}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const getPlaceDetailsService = async (access_key, user_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religious_place/get_place_detail/${access_key}/${user_access_key}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const followReligiousPlaceService = async (user_access_key, religious_place_access_key) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user_religious_place/create`,{user_access_key, religious_place_access_key})
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const unfollowReligiousPlaceService = async (id) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_API_URL}/api/user_religious_place/delete/`+id)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listFollowedReligiousPlaceService = async (user_access_key, page) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/user_religious_place/list_by_user_access_key/`+user_access_key+'/'+page)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listFollowersService = async (user_access_key, page) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/user_religious_place/list_followers/`+user_access_key+'/'+page)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const startStripeConnectOnboardingService = async (payload) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/religious_place/connect/start`, payload)
        .then((response) => ({ success: true, data: response?.data }))
        .catch((error) => {
            console.log(error)
            return { success: false, data: null, message: error?.response?.data?.message || 'server_error' }
        })
    } catch (error) {
        return { success: false, data: null, message: 'server_error' }
    }
}

export const getStripeConnectStatusService = async (user_access_key, religious_place_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religious_place/connect/status/${user_access_key}/${religious_place_access_key}`)
        .then((response) => ({ success: true, data: response?.data }))
        .catch((error) => {
            console.log(error)
            return { success: false, data: null, message: error?.response?.data?.message || 'server_error' }
        })
    } catch (error) {
        return { success: false, data: null, message: 'server_error' }
    }
}

